"use strict";

document.addEventListener("DOMContentLoaded", () => {
    materialsSummary();
});

const materialsSummary = () => {

    const wrappers = document.querySelectorAll('.materials-summary');

    wrappers.forEach(wrapper => {
        const summary = wrapper.querySelector('.summary');
        const moreWrap = summary.querySelector('.more');
        const moreBtn = moreWrap ? moreWrap.querySelector('.btn--more') : null;

        let localPage = 1;

        const loadPosts = (isAppend = false) => {
            const formData = new FormData();
            formData.append('action', 'load_morematerials_action');
            formData.append('_wpnonce', scriptObj.nonce);
            formData.append('type', summary.dataset.type);
            formData.append('perPage', summary.dataset.perpage);
            formData.append('pp', localPage);
            formData.append('lang', scriptObj.lang);

            fetch(scriptObj.ajaxurl, { method: 'POST', body: formData })
                .then(res => res.json())
                .then(data => {

                    const hasNewItems = data.data && data.data.trim().length > 0;

                    if (hasNewItems) {
                        if (isAppend) {
                            moreWrap.insertAdjacentHTML('beforebegin', data.data);
                        } else {
                            [...summary.children].forEach(child => {
                                if (!child.classList.contains('more')) {
                                    child.remove();
                                }
                            });
                            moreWrap.insertAdjacentHTML('beforebegin', data.data);
                        }
                    }

                    if (!hasNewItems || localPage >= data.max) {
                        moreWrap.classList.add('hidden');
                    } else {
                        moreWrap.classList.remove('hidden');
                    }
                })
                .catch(err => console.error(err));
        };

        if (moreBtn) {
            moreBtn.addEventListener('click', e => {
                e.preventDefault();
                localPage++;
                loadPosts(true);
            });
        }
    });
};
